import { SessionContext } from '@contexts/session-context';
import { UserPreferenceContext } from '@contexts/user-preference-context';
import { Page } from '@models/page';
import { UserProjectMapping } from '@models/user-project-mapping.model';
import UserProjectMappingService from '@services/user-project-mapping.service';
import { Avatar, Icon } from '@testsigma/atoms';
import classNames from 'classnames';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { ProfileDropDown } from './profile-dropdown';

interface profileMenuProps {
  showChildrenWithText?: boolean;
  isSidebarhovered?: boolean;
  setIsSidebarhovered?: (flag: boolean) => void;
}

const Index: React.FC<profileMenuProps> = ({
  showChildrenWithText,
  isSidebarhovered,
  setIsSidebarhovered,
}) => {
  const { session } = useContext(SessionContext);
  const { userPreference, setOrUpdatePreference } = useContext(
    UserPreferenceContext,
  );
  const user = session?.user;
  const [userRole, _updateUserRole] = useState('');
  const [showDropdown, setShowDropdown] = useState<boolean>(false);
  const [btnRef, setBtnRef] = useState(null);

  const updateUserRole = useCallback(
    (data) => {
      _updateUserRole(data);
    },
    [_updateUserRole],
  );

  useEffect(() => {
    UserProjectMappingService.findAll(
      `?query=userId:${session.user.id},projectId:${userPreference.preference.projectPreference.projectId}`,
    ).then((res: Page<UserProjectMapping>) =>
      updateUserRole(res.content[0].role.name),
    );
  }, [updateUserRole]);

  const toggleDropdown = (flag: boolean) => {
    setShowDropdown(flag);
    if (isSidebarhovered) setIsSidebarhovered(flag);
  };

  // get user avatar url location
  const getSrcUrl = () => {
    const match = import.meta.env.VITE_ID_SERVICE_URL.match(/^(.+?)\/ui\//);
    const baseUrl = match[1];
    const url = `${baseUrl}/users/${session?.user?.identityUserAccountUUId}/avatar`;
    return url;
  };

  return (
    <>
      <div
        ref={setBtnRef}
        onClick={() => toggleDropdown(!showDropdown)}
        className={classNames(
          {
            'px-0.5': showChildrenWithText,
          },
          { 'justify-center': !showChildrenWithText },
          'basis-full py-md flex overflow-hidden cursor-pointer',
        )}>
        <Avatar
          src={getSrcUrl()}
          alt={`${session?.user?.name}`}
          className='flex flex-none items-center justify-center uppercase !bg-warning-200 !border-none'
        />
        {showChildrenWithText && (
          <div className={'flex flex-wrap pl-md overflow-hidden max-h-8'}>
            <div className='basis-full truncate text-secondary-700 text-small leading-5 font-medium'>
              {user?.name}
            </div>
            <div className='basis-full truncate text-2xs text-secondary-500 flex'>
              <span>{user?.userRole || userRole}</span>
              <Icon
                name='crown'
                className={classNames(
                  { 'text-unique-300': user.isSuperAdmin && !user.isAdmin },
                  { 'text-warning-300': user.isAdmin },
                  {
                    'text-secondary-400': !(user.isSuperAdmin || user.isAdmin),
                  },
                  'pl-1 text-small leading-5',
                )}
              />
            </div>
          </div>
        )}
        {showChildrenWithText ? (
          <Icon className='text-lg block ml-auto' name='angle-right' />
        ) : null}
      </div>
      {showDropdown && (
        <ProfileDropDown
          btnRef={btnRef}
          session={session}
          user={user}
          toggleDropdown={toggleDropdown}
          userRole={userRole}
          isSidebarExpanded={showChildrenWithText}
        />
      )}
    </>
  );
};

export default Index;
